
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isArray } from 'lodash';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Direction } from '../../service/direction.dto';
import { StpImporterService } from '../../service/importer-stp.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'importer-stp-direction-selector',
  templateUrl: './direction-selector.component.html',
  styleUrls: ['./direction-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DirectionSelectorComponent),
      multi: true
    }
  ]
})
export class DirectionSelectorComponent implements ControlValueAccessor {
  @Input() type: 'kppId' | 'name' = 'name';
  @Input() multiple: boolean = false;

  availableDirections: AvaliableDir[] = [];
  private filtered = new Subject<AvaliableDir[]>();
  filtered$ = this.filtered.asObservable();
  value: string | number | string[] | number[] | null = null;
  disabled: boolean = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(private importerService: StpImporterService) { }

  @Input() set carrierId(carrierId: null | number) {
    if (carrierId != null) {
      this.importerService.getAllDirections(carrierId)
        .pipe(
          map(v => v.map(l => new AvaliableDir(l.name, this.getOptionValue(l), l.line.kppId)))
        )
        .subscribe(s => {
          this.availableDirections = s;
          this.filtered.next(this.availableDirections);
        });
    } else {
      this.availableDirections = [];
      this.filtered.next(this.availableDirections);
      this.onSelectChange(null);
    }
  }

  @Input() set linesKppIds(kppIds: null | number[]) {
    if (kppIds == null) {
      this.filtered.next(this.availableDirections);
    } else {
      const filteredDirections = this.availableDirections.filter(d => kppIds.includes(d.lineKppId));
      this.filtered.next(filteredDirections);

      if (this.value != null && isArray(this.value)) {
        const options = new Set(filteredDirections.map(d => d.value));
        const stillValid = (this.value as any[]).filter(v => options.has(v));
        if (stillValid.length !== this.value.length) {
          this.onSelectChange(stillValid.length > 0 ? stillValid : null);
        }
      } else if (this.value != null) {
        const options = new Set(filteredDirections.map(d => d.value));
        if (!options.has(this.value as any)) {
          this.onSelectChange(null);
        }
      }
    }
  }

  getOptionValue(item: Direction): any {
    return this.type ? item[this.type] : item;
  }

  writeValue(value: string | number | string[] | number[] | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectChange(value: string | number | string[] | number[] | null): void {
    this.value = value;
    this.onChange(value);
  }

}

class AvaliableDir {
  constructor(
    public readonly displayValue: string,
    public readonly value: number | string,
    public readonly lineKppId: number
  ) { }
}
